import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

/**
 * Бутон „Назад“ за мобилни екрани, където няма браузърен chrome.
 * Ако има история в SPA-то, връща една стъпка; иначе отива към таблото
 * на логнатия потребител.
 */
const PageBackButton: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBack = () => {
    const historyIndex = window.history.state?.idx;
    if (typeof historyIndex === 'number' && historyIndex > 0) {
      navigate(-1);
      return;
    }

    const userId = user?.id;
    const userType = user?.user_type || localStorage.getItem('user_type');
    if (userId && userType === 'professional') {
      navigate(`/profile/professional/${userId}/dashboard`);
      return;
    }
    if (userId) {
      navigate(`/profile/client/${userId}/dashboard`);
      return;
    }
    navigate('/');
  };

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={handleBack}
      data-testid="page-back-button"
      sx={{ mb: 2, minHeight: 44, alignSelf: 'flex-start' }}
    >
      {t('common.back')}
    </Button>
  );
};

export default PageBackButton;
